/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import { styled } from 'fierry/react';

import Text from 'solis/react/primitive/text';
import ControlHeadline from 'solis/claude/element/zone/control/headline';
import ControlWinner from 'solis/claude/element/zone/control/winner';


const Container = styled(Flex)`
  white-space: nowrap;
`;


export default (props) =>
(
  <Container justify = 'between' align = 'center' gap = '2'>

    <Flex align = 'center' gap = '1'>

      <Text.Label>Control</Text.Label>

      <ControlHeadline {...props} />

    </Flex>

    <ControlWinner {...props} />

  </Container>
);
